import React from 'react';
import Image from 'next/image';
import { Typography } from '@pw-tech/omni-ui';
const Fail = () => {
  return <article className="mt-6" data-sentry-component="Fail" data-sentry-source-file="Fail.tsx">
      <div className="relative flex p-5 bg-[#FFFBFA] rounded-lg gap-2 text-center items-center shadow-[0px_1px_8px_0px_rgba(0,0,0,0.08)]">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/7fc697aa-79f3-43ba-85bc-818acc5d6653.svg" alt="heart-broken" width={120} height={120} className="absolute bottom-0 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Fail.tsx" />
        <div className="z-10 flex flex-col gap-3">
          <div className="flex flex-col items-center gap-3">
            <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/f76fdf66-62cb-4dc5-917f-7f7cd952db75.svg" alt="leafs" width={150} height={150} data-sentry-element="Image" data-sentry-source-file="Fail.tsx" />
            <div>
              <Typography variant="heading3" weight="semi-bold" className="!text-sm sm:!text-lg" data-sentry-element="Typography" data-sentry-source-file="Fail.tsx">
                Unfortunately, You have not been shortlisted.
              </Typography>
              <Typography variant="regular" className="!text-sm !text-[#757575]" data-sentry-element="Typography" data-sentry-source-file="Fail.tsx">
                We understand this news may be disappointing, but remember — this result does not
                define your potential.
              </Typography>
            </div>
          </div>
        </div>
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/7fc697aa-79f3-43ba-85bc-818acc5d6653.svg" alt="heart-broken" width={120} height={120} className=" absolute bottom-0 right-4 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="Fail.tsx" />
      </div>
    </article>;
};
export default Fail;